import React from "react"

export interface DialectInfoEntry {
  label: string
  region: string
  summary: string
}

// Surfaceable points about each of the four variations. Static reference content, like the grammar
// glossary. The Caighdeán is the written standard (the base); the three are the spoken dialects.
export const DIALECT_INFO: Record<string, DialectInfoEntry> = {
  standard: {
    label: "Standard",
    region: "An Caighdeán Oifigiúil",
    summary:
      "The official written standard, used in documents, signage, and textbooks. Not a spoken dialect: the neutral base the others vary from.",
  },
  munster: {
    label: "Munster",
    region: "Cork · Kerry · Waterford",
    summary:
      "Keeps synthetic verb forms (molaim, molaid) where the standard is analytic. Stress often falls on a long vowel later in the word.",
  },
  connacht: {
    label: "Connacht",
    region: "Conamara · Mayo",
    summary:
      "The most widely taught dialect, home to the largest Gaeltacht. Broadly analytic, close to the standard.",
  },
  ulster: {
    label: "Ulster",
    region: "Donegal",
    summary:
      "First-syllable stress and clipped sounds; the closest to Scottish Gaelic. Uses cha/chan for negation instead of ní.",
  },
}

/** A small card describing the selected dialect's characteristics. */
export const DialectCard: React.FC<{ dialect: string }> = ({ dialect }) => {
  const info = DIALECT_INFO[dialect]
  if (!info) return null

  return (
    <div
      className="mt-6 text-xs text-muted-foreground"
      data-testid="dialect-info"
    >
      <span className="font-semibold text-foreground">{info.label}</span>{" "}
      <span className="italic">({info.region})</span>
      <p className="mt-1">{info.summary}</p>
    </div>
  )
}

export default DialectCard
